
export enum MiscLineItemPaymentMethodCd {
	CERTIFIED_FUND = 'CertifiedFund',
	COMPANY_CHECK = 'CompanyCheck',
	CUSTOMER_CHECK = 'CustomerCheck',
	DEMAND_DRAFT = 'DemandDraft',
	MONEY_ORDER = 'MoneyOrder'}

